import React from 'react';
import Button from '@mui/material/Button';
import { __ } from '../../Lang.js';

const VideoErrorState = ({ message }) => {
  return (
    <div className="video-error-container">
      <div className="video-error-icon">!</div>
      <h3 className="video-error-title">{ __('Error Loading Videos') }</h3>
      <p className="video-error-message">{message || 'An error occurred while loading videos.'}</p>
      <Button
        className="video-error-retry"
        variant="contained"
        onClick={() => window.location.reload()}
        sx={{
          backgroundColor: '#e50914',
          color: 'white',
          padding: '0.6rem 1.5rem',
          borderRadius: '4px',
          fontWeight: 500,
          '&:hover': { backgroundColor: '#f40612' },
        }}
      >
        Try Again
      </Button>
    </div>
  );
};

export default VideoErrorState;